export const blockIconsHouseholdYardNew = (
	<span className='material-symbols-outlined'>yard</span>
);
